// extracted by mini-css-extract-plugin
export default {"hdcTiles":"DriversClub_hdcTiles__UKfFT","tile":"DriversClub_tile__JBLYj"};